import { CommonModule } from '@angular/common';
import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { IonIcon, IonItem, IonLabel, IonList, IonMenuToggle } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { AccountService } from '@okcargo-apps/shared-application-ionic';
import { ECapabilities } from '@okcargo-apps/shared-domain-ionic';
import { DECA_ROUTES } from '../../../deca/deca.routes.config';

@Component({
  selector: 'app-menu-main',
  templateUrl: './menu-main.component.html',
  styleUrls: ['./menu-main.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,
    RouterLink,
    RouterLinkActive,
    TranslateModule,
    IonList,
    IonItem,
    IonMenuToggle,
    IonIcon,
    IonLabel,
  ],
})
export class MenuMainComponent {
  private readonly accountService = inject(AccountService);

  protected readonly canViewDecaAsShipper = computed(() =>
    this.accountService.hasCapability(ECapabilities.VIEW_DECA_AS_SHIPPER),
  );

  protected readonly canViewDecaAsCarrier = computed(() =>
    this.accountService.hasCapability(ECapabilities.VIEW_DECA_AS_CARRIER),
  );

  protected readonly canCreateDecaAsShipper = computed(() =>
    this.accountService.hasCapability(ECapabilities.CREATE_DECA_AS_SHIPPER),
  );

  protected readonly canCreateDecaAsCarrier = computed(() =>
    this.accountService.hasCapability(ECapabilities.CREATE_DECA_AS_CARRIER),
  );

  protected readonly canCreateDeca = computed(() => this.canCreateDecaAsShipper() || this.canCreateDecaAsCarrier());

  protected readonly DECA_ROUTES = DECA_ROUTES;

  // constructor() {}
}
